import { useEffect, type ReactNode } from 'react';

export interface ToastProps {
  title?: ReactNode;
  children: ReactNode;
  /** Milliseconds before the toast auto-dismisses. Default 4500. */
  durationMs?: number;
  onDismiss: () => void;
  className?: string;
  /** Pass-through data-testid for the root element. Defaults to "toast". */
  'data-testid'?: string;
}

export function Toast({
  title,
  children,
  durationMs = 4500,
  onDismiss,
  className,
  'data-testid': testId = 'toast'
}: ToastProps) {
  useEffect(() => {
    const t = window.setTimeout(onDismiss, durationMs);
    return () => window.clearTimeout(t);
  }, [durationMs, onDismiss]);

  const cls = ['pn-toast', className].filter(Boolean).join(' ');
  return (
    <div className={cls} role="status" aria-live="polite" data-testid={testId}>
      {title ? <strong className="pn-toast-title">{title}</strong> : null}
      <span className="pn-toast-body">{children}</span>
      <button
        type="button"
        className="pn-toast-dismiss"
        aria-label="Dismiss"
        onClick={onDismiss}
      >
        ×
      </button>
    </div>
  );
}
